import React from 'react';

import { makeStyles } from '@mui/styles';

import RemoveIcon from '@mui/icons-material/Clear';

const useStyles = makeStyles({
  container: (props) => ({
    display: 'inline-flex',
    marginRight: (props.position === 'last' || props.position === 'single') ? 0 : 3,
  }),
  predicateContainer: ({ rstColor, removable }) => ({
    zIndex: 1,
    fontSize: 12,
    background: '#fff',
    alignItems: 'center',
    position: 'relative',
    color: `#${rstColor}`,
    display: 'inline-flex',
    padding: !removable ? '2px 2px 2px 5px' : '2px 0px 2px 5px',
    border: `1px solid #${rstColor}`,
  }),
  firstPredicateContainer: () => ({
    borderRight: 'none',
  }),
  middlePredicateContainer: () => ({
    marginLeft: 7,
    borderLeft: 0,
    borderRight: 0,
  }),
  lastPredicateContainer: () => ({
    borderLeft: 'none',
    marginLeft: 7,
  }),
  removeIcon: {
    fontSize: 16,
    marginLeft: 3,
    cursor: 'pointer',
  },
  leftSkew: ({ rstColor }) => ({
    width: 8,
    marginRight: -8,
    display: 'block',
    borderRight: '0',
    background: '#fff',
    transformOrigin: 'bottom left',
    transform: 'skew(-10deg, 0deg)',
    border: `1px solid #${rstColor}`,
  }),
  rightSkew: ({ rstColor }) => ({
    width: 8,
    marginLeft: -8,
    borderLeft: '0',
    display: 'block',
    borderBottom: '0',
    background: '#fff',
    transformOrigin: 'bottom left',
    transform: 'skew(-10deg, 0deg)',
    border: `1px solid #${rstColor}`,
  }),
});

export default (
  props = {
    mode: 'edit',
  }
) => {
  const removable = props.mode === 'edit';

  const classes = useStyles({
    rstColor: props.color || 'EC87A4',
    position: props.position,
    removable,
  });

  return (
    <div className={classes.container}>
      {props.position === 'last' || props.position === 'middle' ? <div className={classes.leftSkew} /> : null}

      <div
        className={`${classes.predicateContainer} ${
          props.position ? classes[`${props.position}PredicateContainer`] : null
        }`}
      >
        <div className={classes.alignCenter}>
          <span>
            [{props.rst.id}] {props.rst.title} {' '}
          </span>
          <span style={{ fontStyle: 'italic', fontSize: '10px' }}>
            {props.showType ? `(${props.rst.type})` : ''} {' '}
          </span>
        </div>

        {removable ? (
          <RemoveIcon className={classes.removeIcon} onClick={() => props.onRemoveBtnClick(props.index)} />
        ) : null}
      </div>

      {props.position === 'first' || props.position === 'middle' ? <div className={classes.rightSkew} /> : null}
    </div>
  );
};
